/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, clearMessage } from "_redux/actions/authAction";
import authSvc from "services/authSvc";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Alert } from "utils/Alert";
import FormTitle from "./components/FormTitle";
import Input from "./components/Input";
import Checkbox from "./components/Checkbox";
import Button from "./components/Button";
import InputPassword from "./components/InputPassword";
import Logo from "components/Header/Logo";
import ButtonV2 from "components/ButtonV2";

import "./authPage.scss";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
`;

const InlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: 100%;
  margin-top: -10px;
  margin-bottom: 48px;
`;

const ForgotPW = styled.div`
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  color: #ff276b;
  text-align: end;
`;

const FormLogin = () => {
  const initialValidation = {
    email: { isValid: true, msg: "" },
    password: { isValid: true, msg: "" },
  };

  const [form, setForm] = useState();
  const [isRemember, setIsRemember] = useState(false);
  const [validation, setValidation] = useState();
  const [isLoading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(clearMessage());
    if (!form) {
      const rememberData = authSvc.getRemember();

      const newForm = {
        email: rememberData?.email ?? "",
        password: rememberData?.password ?? "",
      };

      setForm(newForm);

      setValidation(initialValidation);
    }
  }, []);

  useEffect(() => {
    if (message && form) {
      resolveAPIMessage();
    }
  }, [message]);

  const onSubmit = () => {
    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const urlParams = window.location.href;
    setLoading(true);

    dispatch(login(form.email, form.password))
      .then(() => {
        onRememberMe(form.email, form.password);
   
        if (
          urlParams.includes("staging") ||
          urlParams.includes("qa-") ||
          urlParams.includes("localhost")
        ) {
          localStorage.setItem("current_set", "staging");
        }
        redirectToMenu();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const validateForm = () => {
    let validationForm = initialValidation;
    const { email, password } = form;
    if (!email) {
      validationForm = {
        ...validationForm,
        email: { ...validationForm.email, isValid: false, msg: "Email is required" },
      };
    }
    if (!password) {
      validationForm = {
        ...validationForm,
        password: { ...validationForm.password, isValid: false, msg: "Password is required" },
      };
    }
    // if (email && !isEmail(email)) {
    //   validationForm = {
    //     ...validationForm,
    //     email: { ...validationForm.email, isValid: false, msg: "Email not valid" },
    //   };
    // }

    setValidation(validationForm);

    let result = true;
    Object.entries(validationForm).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
    });
    return result;
  };

  const resolveAPIMessage = () => {
    Alert.showStatus("error", "Error!", message.msg);
  };

  const onRememberMe = (email, password) => {
    if (isRemember) {
      authSvc.setRemember(email, password);
    } else {
      authSvc.removeRemember();
    }
  };

  const redirectToMenu = () => {
    // return history.push("/my-application");
    return location.href = '/'
  };

  const redirectToForgotPW = () => {
    history.push("/auth/forgot-password");
  };

  if (isLoggedIn) {
    redirectToMenu();
  }

  return (
    <>
      <Container className="col-12 col-md-8 mx-auto">
        <Logo src={require("_assets/icons/oca-logo.svg").default} className="mb-5" />
        <h1 className="fweight-600 fsize-32 cl-neutral600">Log in</h1>
        <p className="fsize-14 cl-neutral100 fweight-400">
          Fill in your email and password to login oca API
        </p>
        <Input
          source="login"
          id="email"
          label="Email"
          type="email"
          placeholder="Input your email"
          value={form?.email}
          error={validation?.email}
          onChange={(value) => setForm({ ...form, email: value })}
        />
        <div className="d-flex flex-column position-relative w-100">
          <InputPassword
            source="login"
            id="password"
            label="Password"
            placeholder="Input your password"
            value={form?.password}
            error={validation?.password}
            onChange={(value) => setForm({ ...form, password: value })}
          />
        </div>
        <InlineContainer>
          {/* <Checkbox
              id="rememberme"
              label="Remember Me"
              value={isRemember}
              onChange={() => setIsRemember(!isRemember)}
            /> */}
          <ForgotPW onClick={() => redirectToForgotPW()}>Forgot Password?</ForgotPW>
        </InlineContainer>
        <ButtonV2
          className="mt-2 w-100"
          register
          backgroundColor="#3B3B47"
          textColor="#FFFFFF"
          padding=".360rem 1rem"
          disabled={!form?.password || !form?.email}
          handleRoute={() => onSubmit()}
          loadingCreate={isLoading}
        >
          Login
        </ButtonV2>
        {/* <Button label="Login" loading={isLoading} disabled={!form?.password || !form?.email} onClick={() => onSubmit()} /> */}
        {/* <span role="not-have-account" className="fsize-14 fweight-500 cl-black2 mt-3 line-height-24 ltr-spaccing-2">
          Don’t have an account?
          <strong
            onClick={() => history.push("/auth/register")}
            className="cl-primary fweight-600 cursor-pointer"
          >
            {" "}
            Sign up
          </strong>
        </span> */}
      </Container>
    </>
  );
};

const LoginPage = () => {
  return <FormLogin />;
};

export default LoginPage;
